import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const AboutContactUs = () => {
  return (
    <div id='website-responsive'>
    <div className='left-padding10rem1 right-padding10rem1 pymd-5 py4'>
    <div className='left-padding7rem right-padding7rem py-md-5 py-4'>
        <div className='py-4 mb-md-4' style={{ boxShadow:'0 0 10px 0 rgba(0,0,0,.5)'}}>
            <div className='fs-ss-20 text-montserrat fw-600 text-ss-black lh-1-4 px-md-5'>
                <center>
                Let us know what<span className='text-ss-primary'> Lab tests</span> you’re looking for, and we’ll have a representative team member to contact you.<br/>
                <span className='text-ss-primary'>Get in Touch or Book your Test!</span>
                <div className='pt-2'>
                <hr className='hr-style my-md-2 mt-2 mt-md-0 ' style={{ width:'130px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>
                </center>
            </div>

            <div className='py-3'>
            <center>
            <Link to='/book-appointment'>
            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'12px 14px',}}>
                    Book A Test Now
                </text>
            </Button>
            </Link>
            </center>
            </div>
        </div>
        </div>
    </div>
</div>
  )
}

export default AboutContactUs